export default {
  TD: 'TD Canada Trust',
  GL: 'General Lender Offering',
};
